import { APIAction } from 'types'

export const actions = {
  fetchFeatureToggles: (): APIAction => ({
    CALL_API: {
      type: 'FETCH_FEATURE_TOGGLES',
      method: 'GET',
      endpoint: '/api/feature_toggles/',
    },
  }),
}
